<template>
  <div class="mob-remove-table-fixed container-list">
    <Row>
      <Col :md="nodeListSpan" v-show="nodeListShow">
        <Card>
          <nodeList ref="nodeList" v-on:nodeChange="getTableData()"></nodeList>
        </Card>
      </Col>
      <Col :md="contentSpan" style="border-left: 16px solid #f5f7f9">
        <Card>
          <Row class="sm-pc-w100">
            <Col :sm="13">
              <span>
                <Button @click="nodeListShowBtn(false)" v-show="nodeListShow" type="primary" size="small" :style="{float: 'left', marginRight: '10px'}" class="mob-hidden">
                  <Icon type="ios-arrow-back" />
                </Button>
                <Button @click="nodeListShowBtn(true)" v-show="!nodeListShow" type="primary" size="small" :style="{float: 'left', marginRight: '10px'}">
                  <Icon type="ios-arrow-forward" />
                </Button>
              </span>
              <Form :model="tableSearchForm" ref="tableSearchForm" inline :label-width="60" @submit.native.prevent>
                <FormItem label="容器名称">
                  <Input v-model="tableSearchForm.name" style="min-width: 200px" />
                </FormItem>
                <FormItem label="容器ID">
                  <Input v-model="tableSearchForm.id" style="min-width: 200px" />
                </FormItem>
                <FormItem :label-width="0" class="mob-align-right">
                  <Button type="primary" @click="getTableData()">搜索</Button>
                  <Button style="margin-left: 8px" @click="clearSearchForm">重置</Button>
                </FormItem>
              </Form>
            </Col>
            <Col :sm="11" class="align-right" style="padding-bottom: 10px">
              <Button
                style="float: right; margin-left: 20px; margin-bottom: 10px"
                @click="$router.push({name: 'container_add'})"
                type="primary"
                icon="md-add">部署容器</Button>
              <ButtonGroup style="padding-bottom: 10px">
                <Button :disabled="!selected.length" @click="batchAction('start')" :loading="batchSubmitting">
                  <Icon style="font-family: 'iconfont'" type="iconfont icon-run" color="#19be6b" size="14"/>
                  <span> 启动</span>
                </Button>
                <Button :disabled="!selected.length" @click="batchAction('restart')" :loading="batchSubmitting">
                  <Icon type="md-refresh-circle" color="#ff9900" size="15" />
                  <span> 重启</span>
                </Button>
                <Button :disabled="!selected.length" @click="batchAction('stop')" :loading="batchSubmitting">
                  <Icon style="font-family: 'iconfont'" type="iconfont icon-stop" size="13" color="#ed4014"/>
                  <span> 停止</span>
                </Button>
                <Button :disabled="!selected.length" @click="batchAction('pause')" :loading="batchSubmitting">
                  <Icon style="font-family: 'iconfont'" type="iconfont icon-pause" size="17" color="#ff9900"/>
                  <span> 暂停</span>
                </Button>
                <Button :disabled="!selected.length" @click="batchAction('unpause')" :loading="batchSubmitting">
                  <Icon type="md-checkmark-circle" color="#19be6b" size="15"/>
                  <span> 恢复</span>
                </Button>
                <Button :disabled="!selected.length" @click="batchAction('delete')" :loading="batchSubmitting">
                  <Icon style="font-family: 'iconfont'" type="iconfont icon-delete" color="#ed4014"/>
                  <span> 销毁</span>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Alert type="success" show-icon v-if="successMsg">{{ successMsg }}</Alert>
          <Alert type="error" show-icon v-if="errorMsg">{{ errorMsg }}</Alert>
          <Alert type="warning" show-icon v-if="not_conn.length">
            <span>连接失败的节点：</span>
            <span v-for="(item, index) in not_conn" :key="index">「{{ item }}」</span>
          </Alert>
          <Alert v-if="listError" type="warning" show-icon>获取数据失败</Alert>
          <Table
            v-else
            border
            highlight-row
            @on-selection-change="selectRow"
            :loading="tableLoading"
            ref="table"
            :data="table.data"
            :columns="table.columns">
            <template slot="ActionMenu" slot-scope="props">
              <ActionMenu :container="props.container" v-on:callback="getTableData(table.page)"></ActionMenu>
            </template>
          </Table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: left;">
              当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
            </div>
            <div style="float: right;">
              <page
                :total="table.count"
                :current="table.page"
                :page-size="table.size"
                @on-change="getTableData"></page>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { getContainers, BatchActionContainer } from '@/api/container/container'
import ActionMenu from './components/ActionMenu'
import moment from 'moment'
import nodeList from '../components/node-list'

export default {
  name: 'list',
  components: {
    nodeList,
    ActionMenu
  },
  data () {
    return {
      tableLoading: false,
      tableSearchForm: {
        name: '',
        id: ''
      },
      table: {
        data: [],
        columns: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '容器名称',
            key: 'Name',
            align: 'center',
            tooltip: true,
            minWidth: 150,
            render: (h, params) => {
              let name = params.row.Name
              if (name.startsWith('/')) {
                name = name.substr(1)
              }
              return h('span', name)
            }
          },
          {
            title: '容器ID',
            key: 'Id',
            align: 'center',
            tooltip: true,
            minWidth: 200
          },
          {
            title: '节点',
            key: 'node_name',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '镜像',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              if (params.row.Config) {
                return h('span', params.row.Config.Image)
              } else {
                return ''
              }
            }
          },
          {
            title: '状态',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              if (params.row.State) {
                let spanData = ''
                let timeData = ''
                let health = ''
                if (params.row.State.Status === 'running') {
                  spanData = 'Up '
                  timeData = params.row.State.StartedAt
                  if (params.row.State.Health) {
                    const healthStatus = params.row.State.Health.Status
                    health = h('span', {
                      style: {
                        color: healthStatus === 'healthy' ? '#19be6b' : healthStatus === 'unhealthy' ? '#ed4014' : '#ff9900',
                        fontWeight: 'bold'
                      }
                    }, ` (${params.row.State.Health.Status})`)
                  }
                } else if (params.row.State.Status === 'paused') {
                  spanData = 'Up '
                  timeData = params.row.State.StartedAt
                } else if (params.row.State.Status === 'exited') {
                  spanData = `Exited (${params.row.State.ExitCode}) `
                  timeData = params.row.State.FinishedAt
                } else {
                  spanData = params.row.State.Status
                }
                let renderData = [
                  h('span', {
                    style: {
                      color: spanData === 'Up ' ? '#19be6b' : '#ed4014',
                      fontWeight: 'bold'
                    }
                  }, spanData)
                ]
                if (timeData) {
                  renderData.push(
                    h('Time', {
                      style: {
                        color: '#999'
                      },
                      props: {
                        time: timeData,
                        interval: 60
                      }
                    })
                  )
                }
                if (params.row.State.Status === 'paused') {
                  if (timeData) {
                    renderData.push(
                      h('span', {
                        style: {
                          color: '#ff9900',
                          fontWeight: 'bold'
                        }
                      }, ' (paused)')
                    )
                  }
                }
                if (health) {
                  renderData.push(health)
                }
                return h('span', renderData, params.row.State.Status)
              } else {
                return ''
              }
            }
          },
          {
            title: '创建时间',
            key: 'Created',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              if (params.row.Created) {
                return h('Time', {
                  props: {
                    time: params.row.Created,
                    interval: 60
                  }
                })
              } else {
                return ''
              }
            }
          },
          {
            title: '操作',
            align: 'center',
            fixed: 'right',
            width: 180,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$router.push({name: 'container_detail', params: {nodeId: params.row.node_id, id: params.row.Id}})
                    }
                  }
                }, '详情'),
                this.$refs.table.$scopedSlots.ActionMenu({
                  container: params.row
                })
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 15
      },
      listError: false,
      not_conn: [],
      node_not_exists: [],
      moment: moment,
      nodeListSpan: 4,
      contentSpan: 20,
      nodeListShow: true,
      selected: [],
      batchSubmitting: false,
      errorMsg: '',
      successMsg: ''
    }
  },
  created: function () {
    this.getTableData()
    this.nodeListShowBtn(true)
  },
  methods: {
    getTableData (value = 1) {
      this.table.page = value
      let reqData = {
        size: this.table.size,
        page: this.table.page,
        nodes: this.$refs.nodeList.selected
      }
      Object.assign(reqData, this.tableSearchForm)
      this.tableLoading = true
      this.selected = []
      getContainers(reqData).then(res => {
        let result = res.data
        this.table.data = result.results
        this.table.count = result.count
        this.not_conn = result.not_conn
        this.node_not_exists = result.node_not_exists
        this.tableLoading = false
        this.listError = false
      }).catch(res => {
        this.tableLoading = false
        this.listError = true
        console.log(res.response)
      })
    },
    clearSearchForm () {
      this.tableSearchForm = {
        name: '',
        id: ''
      }
    },
    nodeListShowBtn (status) {
      this.nodeListShow = status
      if (status) {
        if (this.screenWidth < 1025) {
          this.nodeListSpan = 8
          this.contentSpan = 16
        } else {
          this.nodeListSpan = 4
          this.contentSpan = 20
        }
      } else {
        this.nodeListSpan = 0
        this.contentSpan = 24
      }
    },
    selectRow () {
      this.selected = this.$refs.table.getSelection()
    },
    reqBatchAction (action) {
      let reqData = {
        containers: this.selected,
        action: action
      }
      this.batchSubmitting = true
      BatchActionContainer(reqData).then(res => {
        this.getTableData(this.table.page)
        const result = res.data
        if (!result.error && !result.success) {
          this.errorMsg = result
        } else {
          this.errorMsg = result.error.length ? `${action}操作失败：${result.error.join()}` : ''
          this.successMsg = result.success.length ? `${action}操作成功：${result.success.join()}` : ''
        }
        this.batchSubmitting = false
      }).catch(res => {
        this.batchSubmitting = false
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
        this.successMsg = ''
        this.errorMsg = res.response.data
      })
    },
    batchAction (action) {
      if (action === 'delete') {
        this.$Modal.confirm({
          title: '批量销毁容器',
          content: '确定要批量销毁已选的容器吗？',
          onOk: () => {
            this.reqBatchAction(action)
          }
        })
      } else {
        this.reqBatchAction(action)
      }
    }
  }
}
</script>

<style scoped lang="less">
  .container-list {
    .ivu-col-span-md-4 .ivu-card-bordered .ivu-card-body>div {
      padding: 0!important;
    }
    .ivu-row>div:nth-child(2){
      // border-left: 0!important;
      // margin-top:10px;
    }
    @media screen and (max-width:1900px){
      .ivu-col-span-sm-11,.ivu-col-span-sm-13{
        width:100%;
      }
    }
  }
</style>
